import { LockClosedIcon, UsersIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

export const FOLDER_ACCESS_PROJECT = "project";
export const FOLDER_ACCESS_ADMINS = "admins";

export function folderEffectiveAccess(folderOrNode) {
  if (!folderOrNode) return FOLDER_ACCESS_PROJECT;
  return (
    folderOrNode.effectiveAccess ||
    folderOrNode.effective_access ||
    folderOrNode.object?.effective_access ||
    folderOrNode.access ||
    folderOrNode.object?.access ||
    FOLDER_ACCESS_PROJECT
  );
}

export function isAdminsFolder(folderOrNode) {
  return folderEffectiveAccess(folderOrNode) === FOLDER_ACCESS_ADMINS;
}

export function FolderAccessFields({
  value,
  onChange,
  disabled = false,
  inherited = false,
}) {
  const { t } = useTranslation();
  const current = value === FOLDER_ACCESS_ADMINS ? FOLDER_ACCESS_ADMINS : FOLDER_ACCESS_PROJECT;

  const options = [
    {
      id: FOLDER_ACCESS_PROJECT,
      icon: UsersIcon,
      title: t("document_archive.access_project"),
      hint: t("document_archive.access_project_hint"),
    },
    {
      id: FOLDER_ACCESS_ADMINS,
      icon: LockClosedIcon,
      title: t("document_archive.access_admins"),
      hint: t("document_archive.access_admins_hint"),
    },
  ];

  return (
    <fieldset className="flex flex-col gap-1.5" disabled={disabled}>
      <legend className="text-[13px] font-medium text-[#4A5A57]">
        {t("document_archive.access")}
      </legend>
      {inherited ? (
        <p className="text-xs text-[#8B9895]">
          {t("document_archive.access_inherited")}
        </p>
      ) : null}
      <div className="flex flex-col gap-2">
        {options.map((option) => {
          const selected = current === option.id;
          const Icon = option.icon;
          return (
            <label
              key={option.id}
              className={[
                "flex cursor-pointer items-start gap-3 rounded-[16px] border px-3.5 py-3",
                selected
                  ? "border-[#0F766E] bg-[#E6F2F0]"
                  : "border-[#E5E9E8] bg-[#F5F7F6]",
                disabled ? "cursor-not-allowed opacity-70" : "hover:border-[#CBDBD8]",
              ].join(" ")}
            >
              <input
                type="radio"
                name="folder-access"
                value={option.id}
                checked={selected}
                disabled={disabled}
                onChange={() => onChange(option.id)}
                className="mt-1 h-4 w-4 border-[#CBDBD8] text-[#0F766E] focus:ring-[#0F766E]"
              />
              <Icon className="mt-0.5 h-4 w-4 shrink-0 text-[#0F766E]" />
              <span>
                <span className="block text-sm font-medium text-[#10221F]">
                  {option.title}
                </span>
                <span className="mt-0.5 block text-xs text-[#8B9895]">
                  {option.hint}
                </span>
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
